import React, { createContext, useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";
import instance from "../instance/AxiosInstance";

export const UserContext = createContext();
export const UserContextProvider = ({ children }) => {
    const [User, SetUser] = useState({})
  
    
    useEffect(() => {
        decodeToken()
    }, [])


    const decodeToken = async () => {
        const token = localStorage.getItem('token');
        if (token) {

            const decodedToken = jwtDecode(token);
      console.log(decodedToken.id,'id?-------------git pu-----------------');
            
            instance.get(`/api/user/profile/get_profile/${decodedToken.id}`).then((response)=>{  

                console.log(response.data,"response.data___________________________________");
             
                
                SetUser(response.data);
            }).catch(()=>{
                SetUser(decodedToken._doc);
            })
           
        }

    };

     console.log(User, "usercontext data");
    return (
        <UserContext.Provider value={{ User, SetUser ,decodeToken }}>
            {children}
        </UserContext.Provider>
    )
}